const moment = require('moment');
import { IGoal } from 'motw_core/Entity/IGoal';
import * as React from 'react';
import { Style } from 'source/app/presentation/Shared/Styles/CSS';
import { IGoalDatapointLatest } from '../../../../../../../../../../../motw_core/DTOs/goaldatapointlatest';
import { goalInDangerDaysLimit } from '../../../../../DailyGoals/DailyGoal/DailyGoal';
import { IGoalStreakInfoDTO } from '../../../../../../../../../../../motw_core/DTOs/GoalStreakInfo/IGoalStreakInfoDTO';

export function GoalWeeklyRate({
	goal,
	goalDatapointLatest,
	goalStreakInfo
}: {
	goal: IGoal;
	goalDatapointLatest?: IGoalDatapointLatest;
	goalStreakInfo: IGoalStreakInfoDTO;
}) {
	const textToDisplay = GetTextToDisplay(goal);
	const daysSinceLastDatapoint = GetDaysSinceNow(goalDatapointLatest);

	const isLastDatapointTooOld =
		!goal.is1time && daysSinceLastDatapoint >= goalInDangerDaysLimit;

	const isDisplayTextInfinitySymbol = !goal.is1time;

	return (
		<div
			id="goalWeeklyRate"
			{...Style(
				`goalWeeklyRate_${isDisplayTextInfinitySymbol}_${isLastDatapointTooOld}`,
				{
					position: `relative`,
					color: isLastDatapointTooOld ? `coral` : `inherit`,
					background: isLastDatapointTooOld ? `red` : `inherit`,
					bottom: isDisplayTextInfinitySymbol ? `92px` : `87px`,
					fontSize: isDisplayTextInfinitySymbol ? `17px` : `11px`
				}
			)}
		>
			{textToDisplay}
		</div>
	);
}

function GetTextToDisplay(goal: IGoal) {
	if (!goal.is1time) {
		return `∞`;
	}

	const maxWeeklyRate = 6;

	const roundedWeeklyRate = Math.floor(goal.weeklyrate);

	if (roundedWeeklyRate >= maxWeeklyRate) {
		const daysSinceStart = moment().diff(moment(goal.startdate), 'days');

		return daysSinceStart >= maxWeeklyRate ? 'MAX' : 'WAIT';
	}

	if (roundedWeeklyRate < 1) {
		return 'MIN';
	}

	return '★'.repeat(roundedWeeklyRate);
}

function GetDaysSinceNow(goalDatapointLatest?: IGoalDatapointLatest) {
	if (
		!goalDatapointLatest ||
		!goalDatapointLatest.result_latestdatapointtime
	) {
		return 0;
	}

	return moment().diff(
		moment(goalDatapointLatest.result_latestdatapointtime).local(),
		'days'
	);
}
